/**
 * Global and Material-UI overrides based on designs and pairing
 * We use the theme as a param to make the switch between dark and light easier
 * @param {*} theme - theme to be used as baseline
 */
export const componentOverrides = {
  MuiOutlinedInput: {
    styleOverrides: theme => ({
      notchedOutline: {
        borderColor: theme.palette.grey[500],
      },
    }),
  },
  MuiLink: {
    defaultProps: {
      variant: 'inherit',
      underline: 'hover',
    },
  },
  MuiSlider: {
    styleOverrides: {
      markLabel: {
        top: 20,
      },
    },
  },
  MuiChip: {
    defaultProps: {
      size: 'small',
      shape: 'square',
      variant: 'light',
    },
    styleOverrides: {
      icon: ({ownerState, theme}) => ({
        marginRight: ownerState.label
          ? theme.spacing(-0.5)
          : theme.spacing(0.5),
      }),
      label: ({ownerState, theme}) => ({
        paddingRight: ownerState.label ? theme.spacing(1) : 0,
        paddingLeft: ownerState.label ? theme.spacing(1) : 0,
      }),
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        '& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track': {
          opacity: 1,
        },
      },
    },
  },
  MuiIconButton: {
    variants: [
      {
        props: {shape: 'square'},
        style: {
          borderRadius: theme => theme.shape.borderRadius,
        },
      },
    ],
  },
};
